import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { IMAGES } from "@/lib/constants";

export default function HostLogin() {
  const nav = useNavigate();
  const loc = useLocation();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me").then(() => nav("/host")).catch(() => setChecking(false));
  }, [nav]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/host";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) return <div className="min-h-screen bg-espressoDeep grid place-items-center"><div className="w-10 h-10 rounded-full border-2 border-gold border-t-transparent animate-spin" /></div>;

  return (
    <div className="min-h-screen bg-espressoDeep grain relative grid place-items-center px-5">
      <div className="absolute inset-0 opacity-25"><img src={IMAGES.hero} alt="" className="w-full h-full object-cover" /></div>
      <div className="relative z-10 w-full max-w-sm text-center">
        <p className="text-eyebrow text-goldLight/70">Mike & Sam's Friendsgiving</p>
        <h1 className="font-serif text-4xl text-white mt-3">Host Dashboard</h1>
        <p className="text-white/60 mt-3">Sign in to manage guests, the potluck, and event details.</p>
        {loc.state?.error && <p className="mt-4 text-sm text-[#f0a35a]" data-testid="host-login-error">{loc.state.error}</p>}
        <button onClick={login} className="mt-8 w-full bg-white text-espresso font-semibold py-4 rounded-full flex items-center justify-center gap-3 hover:brightness-95 active:scale-95 transition" data-testid="host-google-login">
          <svg width="20" height="20" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          Sign in with Google
        </button>
        <button onClick={() => nav("/")} className="mt-6 text-sm text-white/50 hover:text-white transition" data-testid="host-login-home">← Back to invitation</button>
      </div>
    </div>
  );
}
